import { useContext, useEffect, useState } from 'react'

import userIcon from '../../assets/icons/user.svg'

import { SL_Modal } from '../../components/modal/Modal'
import { ModalTitle } from './components/ModalTitle'
import { ChoseCentral } from './components/ChoseCentral'
import { ReportTable } from './components/ReportTable'

import { GeneralContext } from '../../context/GeneralContext/GeneralContext'
import { displayMessage } from '../../helpers/messages'
import { EAlertTypes } from '../../enums/EAlertTypes'
import api from '../../services/api'

export const UsersActionModal = ({ onClose }) => {
    const { windowHeight, windowWidth, showAlert } = useContext(GeneralContext)
    const [actions, setActions] = useState(null)
    const [central, setCentral] = useState(null)

    const [appliedFilters, setAppliedFilters] = useState({})

    const [showMore, setShowMore] = useState(true)
    const [showLoading, setShowLoading] = useState(false)
    const filters = ['actionDescrition', 'userName', 'datetime']


    const modalHeigth = windowHeight * 0.7
    const limit = 10

    const columns = [
        {
            dataIndex: 'icon',
            title: '',
            width: 50,
            ellipsis: true,
            noExport: true,
        },
        {
            dataIndex: 'user_first_name',
            title: displayMessage('USER'),
            width: 200,
            ellipsis: true,
        },
        {
            dataIndex: 'ip',
            title: displayMessage('IP'),
            width: 70,
            ellipsis: true,
        },
        {
            dataIndex: 'description',
            title: displayMessage('DESCRIPTION'),
            width: 400,
            ellipsis: true,
        },
        {
            dataIndex: 'date',
            title: displayMessage('DATE_AND_HOUR'),
            width: 240,
            ellipsis: true,
        },
    ]

    const getReportData = async (params = {}, id = central, resetTable) => {
        setShowLoading(true)
        try {
            params = {
                ...params,
                ...resetTable ? {} : appliedFilters,
                limit,
                offset: params?.offset || 0,
                painel: true,
            }
            const { data } = await api.userActionLogs.reportsByCentral(id, params)
            const newActions = data.map((action) => ({ ...action, icon: <img src={userIcon} /> }))
            setActions((current) => ((!current || resetTable) ? newActions : current.concat(newActions)))
            if (limit > data.length) {
                setShowMore(false)
            }
        } catch (error) {
            console.log(error)
        } finally {
            setShowLoading(false)
        }
    }

    const onFilter = (filters, central, cleaning) => {
        if(cleaning) {
            setAppliedFilters({})
            if(central) {
                getReportData({}, central, true)
            } else {
                showAlert(displayMessage("CLEANED_FILTERS_INFO"), EAlertTypes.SUCCESS)
                }
            return 
        }
        setCentral(central)
        setAppliedFilters({})
        setAppliedFilters(filters)
        
        getReportData(filters, central, true)
    }

    useEffect(() => {
        if (central) {
            setActions(null)
            setShowMore(true)
            getReportData(null, central)
        }
    }, [central])

    return (
        <SL_Modal
            open={true}
            title={<ModalTitle onCloseButtonClick={onClose} title={displayMessage('USER_ACTIONS_TITLE')} data={actions} columns={columns} filters={filters} onFilter={onFilter} central_id={central}/>}
            closable={false}
            closeIcon={null}
            footer={null}
            width={windowWidth * 0.9}
            bodyStyle={{
                height: modalHeigth,
                padding: '2.22vh',
            }}
        >
            <ChoseCentral onChangeCentral={setCentral} central_id={central}/>
            <ReportTable columns={columns} data={actions} height={modalHeigth - 200} onShowMore={getReportData} showMoreOptions={showMore} loading={showLoading} limit={limit} filters={appliedFilters} central={central}/>
        </SL_Modal>
    )
}
